import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseManageConsulators } from "./UseManageConsulators";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import {
  capitalizeFirstLetter,
  deCapitalizeFirstLetter,
  toMoney,
} from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import AssignmentIcon from "@mui/icons-material/Assignment";

export default function ConsulatorDetail() {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetConsulatorById } = UseManageConsulators();
  const [consultantRes, setConsultantRes] = useState();
  const [openDescription, setOpenDescription] = useState({
    show: false,
    description: "",
  });

  const [myPcState, setMyPcState] = useState(
    location.state && location.state.myPc
      ? location.state.myPc
      : {
          page: 0,
          sortColumn: "Id",
          sortOrder: "Asc",
          searchColumn: "",
          scrollTo: undefined,
          forceRefresh: false,
        }
  );
  function updatepage(page) {
    setMyPcState({ ...myPcState, page: page, scrollTo: undefined });
  }

  const updatesort = (col, order) => {
    setMyPcState({
      ...myPcState,
      sortColumn: capitalizeFirstLetter(col),
      sortOrder: order,
      sorted: true,
    });
  };

  useEffect(() => {
    if (
      myPcState.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetConsulatorById(myPcState, location.state.id, (consultant) => {
      setConsultantRes(consultant);
    });
  }, [myPcState]);

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowNO",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "userID",
      width: 70,
      align: "center",
      headerName: "شناسه کاربر",
      headerAlign: "center",
      hide: true,
    },

    {
      field: "firstName",
      headerName: "نام",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "product",
      headerName: "محصول",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.product}
          </Typography>
        );
      },
    },
    {
      field: "brand",
      headerName: "برند",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.brand}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "شماره موبایل",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "stateTitle",
      headerName: "وضعیت",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "جزییات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "جزییات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="add Client">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                setOpenDescription({
                  show: true,
                  description: cellValues.row.description,
                });
              }}
            >
              <AssignmentIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/manageconsulators",
        title: "ارتباط با مشتری",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/manageconsulators" },
          { name: "جزییات مشاوره", url: "/manageconsulators/consulatorDetail" },
        ],
      }}
    >
      {consultantRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={consultantRes.pageCondition.pageCount}
          rows={consultantRes.items}
          paginationMode="server"
          page={consultantRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatepage(page + 1);
          }}
          rowCount={consultantRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              opacity: "80%",
              cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .Green": {
              backgroundColor: "#56ff004f !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
            "& .pink": {
              backgroundColor: "#ffdbdb !important",
            },
            "& .orange": {
              backgroundColor: "#FFC36E !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.state == 1) {
              return "Green";
            }
            if (params.row.state == 2) {
              return "red";
            }
            if (params.row.state == 3) {
              return "orange";
            }
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPcState.scrollTo,
              isLtr: true,
              rowCount: consultantRes.pageCondition.totalItemCount,
              nofab: true,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPcState.sortColumn),
                  sort: deCapitalizeFirstLetter(myPcState.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPcState.page,
            },
          }}
          onSortModelChange={(model) => {
            updatesort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}

      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenDescription({ show: false, description: "" });
        }}
        open={openDescription.show}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
            alignItems: "center",
          }}
        >
          <TextField
            label="توضیحات"
            multiline
            rows={6}
            fullWidth
            value={
              openDescription.description ? openDescription.description : ""
            }
            size="small"
            variant="filled"
          />
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => {
              setOpenDescription({ show: false, description: "" });
            }}
          >
            بستن
          </Button>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
